<template>
    <drag-and-drop
        :multiDrop="true"
        @fileDropped="uploadFile"
        :hideDrop="drag"
    >
        <div :id="'uploaded' + id">
            <v-gallery
                :id="'gallery-' + id"
                :images="photos()"
                :index="galleryIndex"
                @close="clearGalleryIndex"
            ></v-gallery>

            <draggable
                v-model="galleryImages"
                :group="id"
                @start="drag = true"
                @end="drag = false"
                draggable=".thumb"
                class="photo-container"
            >
                <div
                    v-for="(image, index) in galleryImages"
                    class="thumb"
                    :id="id.substr(0,3)+'-'+index"
                    :key="index"
                >
                    <button v-if="!previewMode && isDoctor && currentUser.role === 'admin'"
                            type="button"
                            class="copyBtn small blueHover btnDelClGal"
                            @click.prevent.stop="copyImgToAvatar(index)"
                            style="right: 50px;">
                        <i class="fas fa-copy"></i>
                    </button>
                    <button v-if="!previewMode && isModeration"
                            type="button"
                            class="rotateBtn small blackHover btnDelClGal"
                            @click.prevent.stop="rotateImage(index)"
                            style="right: 30px;">
                        <i class="fas fa-rotate-right"></i>
                    </button>
                    <button v-if="!previewMode"
                            type="button"
                            class="resetBtn small redHover btnDelClGal"
                            @click.prevent.stop="removeImage(index)">
                        <i class="fas fa-trash"/>
                    </button>

                    <img
                        :src="prepareSrc(galleryImages[index])"
                        class="photoGallery__img"
                        @click="setGalleryIndex(index, galleryImages[index])"
                    />
                </div>
                <div v-if="!previewMode" style="vertical-align: top; display: inline-block; margin-top: 5px;">
                    <button @click.prevent="showFileChooser" class="upload-button" v-html="buttonText" />
                </div>

            </draggable>
        </div>
        <input v-if="!previewMode"
               type="file"
               style="display: none"
               accept="image/*,.pdf"
               ref="uploadInput"
               @input="inputImgLoadEvent"
               multiple
        />
    </drag-and-drop>

</template>

<script>

import DragAndDrop from '@base/DragAndDrop.vue';
import Draggable from "vuedraggable";
import {mapState} from "vuex";

export default {
    props: {
        id: {
            type: String,
            required: false,
            default: 'gallery'
        },
        previewMode: {
            type: Boolean,
            default: false
        },
        value: {
            type: Array,
            required: true
        },
        imagesBasePath: {
            type: String,
            required: true
        },
        uploadUrl: {
            type: String,
            required: false
        },
        buttonText: {
            type: String,
            required: false
        },
        doctor: {
            type: Object,
            default: () => {},
        },
        isDoctor: {
            type: Boolean,
            default: false,
        },
        isModeration: {
            type: Boolean,
            default: false,
        },
        includeFullSize:{
            type: Boolean,
            default: true,
        },
        openImagesInNewTab: {
            type: Boolean,
            default: false,
        },
    },

    components: {
        'draggable': Draggable,
        DragAndDrop
    },

    data: function () {
        return {
            drag: false,
            imagesPath: this.imagesBasePath,
            galleryIndex: null,
            galleryImages: this.value,
        }
    },

    computed: {
        ...mapState({
            currentUser: state => state.currentUser,
        }),
    },

    mounted: function () {
        let prevButton = document.querySelector('#gallery-photos > .prev');
        let nextButton = document.querySelector('#gallery-photos > .next');

        prevButton.innerHTML = nextButton.innerHTML = '';
    },

    methods: {
       prepareSrc(fileName) {
         return '/'+this.imagesPath +'/'+ fileName.replace('.pdf', '.jpg')
       },
        showFileChooser() {
                this.$refs.uploadInput.click();
        },
        inputImgLoadEvent(event) {
            Array.from(event.currentTarget.files).forEach((file) => {
                this.uploadFile(file)
            })
        },
        uploadFile (file, path = [], index = 0){
            let formData = new FormData();
            formData.append("img", file);
            this.axios.post(this.uploadUrl, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then((resp) => {
                if (resp.data.status === 'success'){
                    this.$emit('file-uploaded', resp.data.urls, this.getPositionByPath(path, index));
                }
            });
        },
        getPositionByPath (path, index){
            let position = this.galleryImages.length;
            let elem = (path.find((elem) => elem.className === 'thumb' ));

            if (elem !== undefined){
                position = parseInt(elem.id.substr(4)) + index;
            }
            return position;
        },
        removeImage: function (index) {
            this.galleryImages.splice(index, 1);
        },

        copyImgToAvatar: function (index) {
            document.querySelector('.photosResult #' + this.id.substr(0,3) + '-' + index + ' .copyBtn').setAttribute('disabled', 'disabled');

            this.axios.post('/admin/doctors/copyPhotoToAvatar', {
                fileName: this.galleryImages[index]
            }).then(() => {
                this.doctor.oldImg = this.doctor.img;
                this.doctor.img = this.galleryImages[index];

                this.axios.get('/storage.public/images/doctors/150x225/' + this.doctor.img, {
                    headers: {
                        'Content-Type': 'image/jpg',
                        'accept': 'image/jpg'
                    },
                    responseType: 'blob'
                }).then(response => {
                    this.doctor.newImgFile = new File([response.data], 'copied' + Date.now() + '.jpg');

                    this.removeCopyBtnDisable(index);
                }).catch(() => this.removeCopyBtnDisable(index, true));
            }).catch(() => this.removeCopyBtnDisable(index, true));
        },

        removeCopyBtnDisable: function (index, immediate = false) {
            if (immediate) {
                document.querySelector('.photosResult #' + this.id.substr(0,3) + '-' + index + ' .copyBtn').removeAttribute('disabled');
                return;
            }
            setTimeout(() => {
                document.querySelector('.photosResult #' + this.id.substr(0,3) + '-' + index + ' .copyBtn').removeAttribute('disabled');
            }, 2000);
        },

        rotateImage: function (index) {
            let oldFileName = this.galleryImages[index];
            document.querySelector('.photosResult #' + this.id.substr(0,3) + '-' + index + ' .rotateBtn').setAttribute('disabled', 'disabled');

            this.axios.post(this.uploadUrl + '/rotate', {
                fileName: this.galleryImages[index]
            }).then((response) => {
                this.galleryImages[index] = response.data.filename;

                let oldSrc = document.querySelector('.photosResult #' + this.id.substr(0,3) + '-' + index + ' img').src;
                document.querySelector('.photosResult #' + this.id.substr(0,3) + '-' + index + ' img')
                    .setAttribute('src', oldSrc.replace(oldFileName, response.data.filename))

                document.querySelector('.photosResult #' + this.id.substr(0,3) + '-' + index + ' .rotateBtn').removeAttribute('disabled');
            }).catch(() => document.querySelector('.photosResult #' + this.id.substr(0,3) + '-' + index + ' .rotateBtn').removeAttribute('disabled'));
        },

        clearGalleryIndex: function () {
            this.galleryIndex = null;
        },

        setGalleryIndex: function (index, galleryImage) {
            if (galleryImage.split('.').pop() === 'pdf' || this.openImagesInNewTab) {
                window.open('/'+this.imagesPath +'/'+ galleryImage, '_blank');
            } else {
                this.galleryIndex = index;
            }
        },

        handleFileUploaded: function (url) {
            this.$emit('file-uploaded', url);
        },

        photos: function () {
            if(this.includeFullSize){
                let origPath = '/'+this.imagesPath.slice(0,this.imagesPath.lastIndexOf("/") + 1)+'fullsize/'
                return this.galleryImages.map(url => {
                    return origPath + url.replace('.pdf', '.jpg');
                });
            }else {
                return this.galleryImages.map(url => {
                    return '/'+this.imagesPath +'/'+ url.replace('.pdf', '.jpg');
                });
            }
        }
    },

    watch: {
        imagesPath: {
            immediate: true,
            handler(newValue) {
                if (newValue !== '') {
                    this.imagesPath = newValue.replace(/(\/$)/, '').replace(/(^\/)/, '');
                }
            }
        },
        value: function (newValue, oldValue) {
            this.galleryImages = newValue;
        },

        galleryImages: function (newValue, oldValue) {
            this.$emit('input', newValue);
        }
    }
}
</script>

<style>
.button_add_img {
    cursor: pointer;
}
.photoGallery__img {
    height: 120px;
    cursor: pointer;
}
 .btnDelClGal {
     min-height: 0px !important;
     padding: 0 !important;
     height: 16px !important;
     width: 16px !important;
 }
 .btnDelClGal i {
     font-size: x-small;
     left: 22%;
     position: absolute;
     top: -15%;
}
.blueimp-gallery {
    margin-left: -5px;
}
.blueimp-gallery > .prev, .blueimp-gallery > .next {
    background-position: center;
    background-size: 30px;
    background-repeat: no-repeat;
}

.blueimp-gallery > .prev {
    background-image: url("/img/gallery-left.png");
}

.blueimp-gallery > .next {
    background-image: url("/img/gallery-right.png");
}

.blueimp-gallery > .close {
    border-bottom: none;
}
.upload-button {
    width: 120px;
    height: 120px;
}
</style>
